import { axios } from 'shared/services/axios'

export function passwordSubmit(authId, password) {
  return axios.post(`/authorization/v1/access_authorizations/${authId}/password`, {password})
    .then(response => response.data)
}
